import React, { useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import globalStyles from "./constants/globalStyles/theme.json";
import GlobalStyle from "./constants/globalStyles/AppStyles";
import NavBar from "./components/Navbar/Navbar";
import Contact from "./Pages/Contact/Contact";
import Home from "./Pages/Home/Home";
import About from "./Pages/About/About";
import Footer from "./components/Footer/Footer";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import NotFound from "./Pages/NotFound/NotFound";

const { colors } = globalStyles;

function App() {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const [hasAnalyticsConsent, setHasAnalyticsConsent] = useState(false);

  const openMenuOverlay = () => {
    setIsOverlayOpen(!isOverlayOpen);
  };

  return (
    <ThemeProvider theme={{ colors }}>
      {hasAnalyticsConsent && <Analytics />}
      {hasAnalyticsConsent && <SpeedInsights />}
      <GlobalStyle />
      <Container>
        <CookieBanner onConsentChange={setHasAnalyticsConsent} />
        <Router>
          <NavBar expandMenu={openMenuOverlay} isMenuExpanded={isOverlayOpen} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-oss" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </Router>
      </Container>
    </ThemeProvider>
  );
}

export default App;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
`;
